import { render, staticRenderFns } from "./regulacaoDivulgacaoLayout.vue?vue&type=template&id=d60a021c&scoped=true&"
import script from "./regulacaoDivulgacaoLayout.vue?vue&type=script&lang=js&"
export * from "./regulacaoDivulgacaoLayout.vue?vue&type=script&lang=js&"
import style0 from "./regulacaoDivulgacaoLayout.vue?vue&type=style&index=0&id=d60a021c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60a021c",
  null
  
)

export default component.exports